import type { Section } from '@common/formEngine/formEngine.types';
import type { NullablePrimitives, ValueOf } from '@common/utils/utilityTypes';
import { werkdiagnoseOptions } from '../lumbarRadiculopathy';

// Aanbevolen vervolg
export const AanbevolenVervolg = {
    anders: 'Anders, namelijk...',
    eerstelijns_fysiotherapie: 'Eerstelijns fysiotherapie',
    expectatief_beleid: 'Expectatief beleid',
    overname_in_tweede_lijn_gewenst: 'Overname in tweede lijn gewenst',
    pijnpoli: 'Pijnpoli',
} as const;
export type AanbevolenVervolg = ValueOf<typeof AanbevolenVervolg>;
export const aanbevolenVervolgOptions = [
    AanbevolenVervolg.expectatief_beleid,
    AanbevolenVervolg.eerstelijns_fysiotherapie,
    AanbevolenVervolg.pijnpoli,
    AanbevolenVervolg.overname_in_tweede_lijn_gewenst,
    AanbevolenVervolg.anders,
];

export type LumbarRadiculopathyAssessmentData = NullablePrimitives<{
    aanbevolen_vervolg: NullablePrimitives<{
        anders: string;
        eerstelijns_fysiotherapie: boolean;
        expectatief_beleid: boolean;
        overname_in_tweede_lijn_gewenst: boolean;
        pijnpoli: boolean;
    }>;
    toelichting: string;
    werkdiagnose: string;
}>;

export const lumbarRadiculopathyAssessmentSections: Section<LumbarRadiculopathyAssessmentData>[] = [
    {
        fields: [
            {
                allowOtherOption: true,
                isRequired: true,
                key: 'werkdiagnose',
                label: 'Werkdiagnose',
                type: 'radioGroup',
                valueOptions: werkdiagnoseOptions,
            },
            {
                checkboxEnumType: AanbevolenVervolg,
                isRequired: true,
                key: 'aanbevolen_vervolg',
                label: 'Aanbevolen vervolg',
                type: 'checkboxGroup',
                valueOptions: aanbevolenVervolgOptions,
            },
            {
                isRequired: true,
                key: 'toelichting',
                label: 'Toelichting',
                type: 'textArea',
            },
        ],
        title: 'Conclusie',
    },
];
